import React from "react";
import { AiOutlinePlus, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Catalog.module.css";
import { CreateCatalogDialog } from "./Dialog/CreateCatalogDialog";
import { UploadingDialog } from "./Dialog/UploadingDialog";
import { useCatalogs } from "./hooks/useCatalog";
import Spinner from "../Spinner/Spinner";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

const PAGE_SIZE = 10;

export const Catalogs = () => {
  const navigate = useNavigate();
  const [page, setPage] = React.useState(1);
  const {
    handleCloseCreateCategoryDialog,
    handleContinueBackground,
    handleOpenCreateCategoryDialog,
    handleSubmitCreateCategoryDialog,
    showCreateCategoryDialog,
    showUploadingDialog,
    catalogs,
    getCatalogsLoading,
  } = useCatalogs();

  const totalPages = catalogs ? Math.ceil(catalogs.length / PAGE_SIZE) : 1;
  const paginated = catalogs
    ? catalogs.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)
    : [];

  if (getCatalogsLoading) {
    return <Spinner />;
  }
  return (
    <div className={styles.catalogcontainer}>
      <div className={styles.upper}>
        <Link to="/">
          <span className={styles.swag}>
            Website
            <span className={styles.greater}> &gt; </span>
          </span>
        </Link>
        <span className={styles.req}>Catalogues</span>
      </div>
      <h1 className={styles.heading}>Catalogues</h1>
      <button
        onClick={handleOpenCreateCategoryDialog}
        className={styles.addbutton}
      >
        <AiOutlinePlus /> New Catalogue
      </button>
      {(!catalogs || catalogs.length === 0) && (
        <p className={styles.noCatalogs}>No catalogs found</p>
      )}
      {catalogs && catalogs.length > 0 && (
        <>
          <div className={styles.catalogsContainer}>
            <table>
              <thead>
                <th>#ID</th>
                <th>Name</th>
                <th>Brand</th>
                <th>Product Count</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Show</th>
              </thead>
              <tbody>
                {paginated.map((catalog) => (
                  <tr
                    key={catalog.id}
                    onClick={() => navigate(`/catalogs/${catalog.id}`)}
                  >
                    <td>#{catalog.id.slice(-3)}</td>
                    <td>{catalog.name}</td>
                    <td>{catalog.brand}</td>
                    <td>{catalog.productCount}</td>
                    <td>{formatDate(catalog.createdAt)}</td>
                    <td>{formatTime(catalog.createdAt)}</td>
                    <td style={{ textTransform: "capitalize" }}>
                      {catalog.status === "processing" ? (
                        <PendingLoader />
                      ) : (
                        `${catalog.status}`
                      )}
                    </td>
                    <td>{catalog.show ? "Yes" : "No"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div className={styles.pagination}>
              <button
                className={styles.pageBtn}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                <AiOutlineLeft />
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <button
                  key={p}
                  className={`${styles.pageBtn} ${p === page ? styles.pageBtnActive : ""}`}
                  onClick={() => setPage(p)}
                >
                  {p}
                </button>
              ))}
              <button
                className={styles.pageBtn}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                <AiOutlineRight />
              </button>
            </div>
          )}
        </>
      )}
      <>
        <CreateCatalogDialog
          show={showCreateCategoryDialog}
          switch={handleCloseCreateCategoryDialog}
          onSubmit={handleSubmitCreateCategoryDialog}
        />
        {showUploadingDialog && (
          <UploadingDialog
            show={showUploadingDialog}
            estimatedMinutes={4}
            onContinueBackground={handleContinueBackground}
          />
        )}
      </>
    </div>
  );
};

const PendingLoader = () => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.spinner}></div>
      <span className={styles.spinnerText}>Processing</span>
    </div>
  );
};
